import {CardEmisionPage} from './CardEmisionPage';
export default CardEmisionPage;